import {type ELeadStage, type ILead, type IMessage} from 'src/services/api';
import {type IShowing} from 'src/api/landlord-showings-api';


export enum ESmartNotificationAction {
    OPEN_SNIPPETS = 'OPEN_SNIPPETS',
    CHANGE_SPECIFIC_STAGE = 'CHANGE_SPECIFIC_STAGE',
    OPEN_TOUR_MODAL = 'OPEN_TOUR_MODAL',
}

export enum ESmartNotificationType {
    default = 'default',
    warning = 'warning',
}

export interface ISmartNotification {
    title: string;
    description: string;
    type: ESmartNotificationType;
    changeToSpecificStage?: ELeadStage;
}

export const DEFAULT_LEAD_NAME = 'this lead' as const;


export type FinderCriteriaFn = (lead: ILead, messages: IMessage[], showings: IShowing[]) => ISmartNotification;
